var React = require('react');

function ChevronR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12,8.85a1,1,0,0,1-.29.71l-5,5A1,1,0,0,1,5.31,13.1L9.56,8.85,5.31,4.6a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l5,5A1,1,0,0,1,12,8.85Z","transform":"translate(-5.02 -2.9)"}));
}

ChevronR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 6.96 11.92"};

module.exports = ChevronR;

ChevronR.default = ChevronR;
